// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"1e6ff35b","82":"70d231fa","247":"445bfa8c","453":"45627d5f","466":"7200cc48","551":"2ec6d862","627":"4dd5a5d6","653":"20320625","867":"1ffae515","923":"d7f35cd3","938":"ae77e40d"}[chunkId] + ".chunk.js";
};